import { Divider } from '@/components/divider/divider'

import { cn } from '@/lib/utils'

import { UploadDocumentContent } from './ui/upload-document-content/upload-document-content'
import { UploadDocumentHeader } from './ui/upload-document-header/upload-document-header'

export const UploadDocumentPage = () => {
  return (
    <main className={cn('p-10')}>
      <UploadDocumentHeader />
      <Divider className={cn('my-6')} />
      <UploadDocumentContent />
    </main>
  )
}
